import { render, staticRenderFns } from "./UserPoll.vue?vue&type=template&id=7f8a6059"
import script from "./UserPoll.vue?vue&type=script&lang=js"
export * from "./UserPoll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports